


























































import { Popover } from 'element-ui'
import { Component, Vue, Prop } from 'vue-property-decorator'

import CustomerNotificationsList from '@/components/CustomerNotificationsList.vue'

import CustomerNotification from '@/models/customer-notification'

import { UtilityGetters } from '@/store/modules/utility'

@Component({
  components: {
    CustomerNotificationsList,
    [Popover.name]: Popover,
  },
})
export default class HeaderUserWidget extends Vue {
  @Prop() customerName!: string
  @Prop() notifications!: CustomerNotification[]
  @Prop() unreadNotificaionsAmount!: number

  notificationsVisible = false
  userWidgetPopupVisible = false

  onNotificationsShow() {
    if (this.isMobileScreen) {
      this.notificationsVisible = false
      this.$router.push({ name: 'notifications' })
      return
    }

    this.$emit('on-notifications-show')
  }

  get isMobileScreen(): boolean {
    return this.$store.getters[UtilityGetters.IsMobileScreen]
  }
}
